import React, { useEffect, useState } from "react";
import {
  PageHeader,
  Breadcrumb,
  Spin,
  Table,
  Tooltip,
  message,
  Button,
  Tag,
} from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import Page from "_components/Page";
import { Link } from "react-router-dom";
import { stockIssueService } from "_services";
import { CurrencyFormatter } from "_helpers/formatters";
import Search from "./Search";
import moment from "moment";

function List({ history, match }) {
  const { path } = match;
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [genearatingExcel, setGeneratingExcel] = useState(false);
  const [wastageData, setWastageData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(
    "?orderStages=OPEN,ISSUED,COMPLETE,READY&pageNumber=1&pageSize=25"
  );

  useEffect(() => {
    getWastageData(searchQuery);
  }, [searchQuery]);

  const getWastageData = async (searchQuery) => {
    try {
      setIsLoading(true);
      const result = await stockIssueService.search(searchQuery);
      setWastageData(result.content);
    } catch (error) {
      console.table(error);
      //message.error(error, 3);
      // setError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getColumns = () => {
    let columns = [];

    columns.push({
      title: "CusDec No#",
      align: "left",
      dataIndex: "customReferenceNumber",
      key: "customReferenceNumber",
      width: "5%",
      render: (text) => <Tag color="#13c2c2">{text}</Tag>,
    });

    columns.push({
      title: "Issue Number",
      align: "center",
      dataIndex: "issueNumber",
      key: "issueNumber",
      width: "5%",
      render: (text, record) => text,
    });

    columns.push({
      title: "Issue Date",
      align: "center",
      dataIndex: "issuedDate",
      key: "issuedDate",
      width: "5%",
      render: (text, record) => moment(text).format("YYYY-MMM-DD"),
    });

    columns.push({
      title: "Material Wastage(Kg)",
      align: "center",
      dataIndex: ["totalWasteQuantity"],
      key: ["totalWasteQuantity"],
      width: "10%",
      render: (text, record) => Number(text ?? 0).toFixed(2),
    });

    columns.push({
      title: "Liability Wastage(LKR)",
      align: "center",
      dataIndex: ["totalWasteTaxAmount"],
      key: ["totalWasteTaxAmount"],
      width: "5%",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    });

    columns.push({
      title: "Wastage (%)",
      align: "center",
      dataIndex: ["wastagePercentage"],
      key: ["wastagePercentage"],
      width: "5%",
      render: (text, record) =>
        Number(
          (record.totalWasteTaxAmount / record.totalLiabilityAmount) * 100
        ).toFixed(2) + " %",
    });

    return columns;
  };
  const onSearch = (data) => {
    setSearchQuery(data);
  };
  const onClear = () => {
    setSearchQuery(
      "?orderStages=OPEN,ISSUED,COMPLETE,READY&pageNumber=1&pageSize=25"
    );
  };
  const onCancel = () => {
    history.push("/");
  };
  const handleExportExcel = async () => {
    try {
      setGeneratingExcel(true);
      const response = await stockIssueService.exportExcel(searchQuery);
      const url = window.webkitURL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Wastage-Report_${moment(new Date()).format("YYYY-MM-DD")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
    } finally {
      setGeneratingExcel(false);
    }

    // reportService
    //   .exportExcel(searchQuery)
    //   .then((response) => {
    //     const url = window.webkitURL.createObjectURL(new Blob([response]));
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute(
    //       "download",
    //       `Available-Stock-Report_${moment(new Date()).format(
    //         "YYYY-MM-DD"
    //       )}.xlsx`
    //     );
    //     document.body.appendChild(link);
    //     link.click();
    //     link.parentNode.removeChild(link);
    //     setLoadingExcel(false);
    //   })
    //   .catch((error) => {
    //     setLoadingExcel(false);
    //     message.error(error);
    //   });
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Tooltip key="tp-mud-pdf" placement="topLeft" title="Export Excel">
        <Button
          key="mud-pdf"
          icon={<FilePdfOutlined />}
          onClick={(e) => {
            e.preventDefault();
            handleExportExcel();
          }}
          loading={genearatingExcel}
        >
          Export Excel
        </Button>
      </Tooltip>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/reports">Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/reports/wastage">Export Wastage</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page error={error}>
          <Search onSearch={onSearch} onClear={onClear} />
          <Spin spinning={isLoading}>
            {wastageData && (
              <Table
                bordered
                pagination={false}
                columns={getColumns()}
                dataSource={wastageData}
                size="small"
              ></Table>
            )}
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default List;
